import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import Loading from "../../components/common/Loading";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  GetAttendanceReport,
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getEditReport,
  getGroup,
  getPages,
  getProfitCenter,
  getPunchRecords,
} from "../../services/dataService";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FilterComponent from "../pages/FilterComponent";
import { IconFilter } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { getSecureItem } from "../../services/SecureStorage";
export default function AttendanceReport() {
  const [dates, setDates] = useState({
    FromDate: "",
    ToDate: "",
  });
  const [data, setData] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [loading, setLoading] = useState(false);
  const [AttendenceReports, setAttendenceReports] = useState([]);
  const UID = getSecureItem("userId");
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  console.log(DepId);

  const isAdmin = getSecureItem("IsAdmin");
  const UserName = getSecureItem("UserName");
  const [editedReport, setEditedReport] = useState([]);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  //  console.log(DepId);

  const [dataFilter, setDataFilter] = useState([]);

  const [PunchRecords, setPunchRecords] = useState([]);

  const [companyDetails, setCompanyDetails] = useState([]);
  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
      console.log(response.data.data[0], "Respocsdnse Data");
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  const fetchPunchRecords = async () => {
    const datesr = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
    };
    try {
      setLoading(true);
      const result = await getPunchRecords(datesr);
      console.log("punch rec result", result);
      setPunchRecords(result.data.data || []);
    } catch (error) {
      console.log("punch rec error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (e) => {
    console.log("ghj");

    const { name, value } = e.target;
    setDates((prevDates) => ({
      ...prevDates,
      [name]: value,
    }));
  };

  const fetchAttendanceReport = async () => {
    const data = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };

    try {
      setLoading(true);
      const response = await GetAttendanceReport(data);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      setAttendenceReports(details);
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

  const fetcheditedInandout = async () => {
    const data = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };

    try {
      setLoading(true);
      const response = await getEditReport(data);
      console.log(response, "sdfsfed");

      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      setEditedReport(details);
    } catch (error) {
      console.error("Error fetching Editedreport data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    fetchAttendanceReport();
    fetcheditedInandout();
  };

  useEffect(() => {
    setDates({
      FromDate: new Date().toISOString().split("T")[0],
      ToDate: new Date().toISOString().split("T")[0],
    });
    fetchAttendanceReport();
    fetcheditedInandout();
  }, [UID]);

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "E_Name",
      selector: (row) => row.EmployeeName,
      sortable: true,
    },

    {
      name: "E_Code",
      selector: (row) => row.EmployeeCode,
      sortable: true,
    },
    {
      name: "Shift",
      selector: (row) => (row.IsWeekly == 1 ? "Weekly Off" : row.ShiftName),
      sortable: true,
    },
    {
      name: "E_Department",
      selector: (row) => row.DepartmentName,
      sortable: true,
    },

    {
      name: "Record date",
      selector: (row) => {
        const date = new Date(row.RECORDDATE);
        return `${date.getDate().toString().padStart(2, "0")}/${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
      },
      sortable: true,
    },

    {
      name: "In Time",
      selector: (row) => {
        if (!row.INTIME) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row.INTIME.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row.INTIME) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row.INTIME.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
    },
    {
      name: "Out Time",
      selector: (row) => {
        if (!row.OUTTIME) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row.OUTTIME.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row.OUTTIME) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row.OUTTIME.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
    },
    {
      name: "Punch In",
      selector: (row) => {
        if (!row?.PUNCHIN) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row?.PUNCHIN.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row?.PUNCHIN) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row?.PUNCHIN.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
    },

    {
      name: "Punch Out",
      selector: (row) => {
        if (!row?.PUNCHOUT) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row?.PUNCHOUT.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row?.PUNCHOUT) {
          return "-"; // Placeholder for null or empty values
        }
        const time = row?.PUNCHOUT.split("T")[1]?.slice(0, 5); // Extract HH:MM
        return time || "-";
      },
    },
    {
      name: "WorkingHour",
      selector: (row) => {
        const decimalHour = parseFloat(row.WORKINGHOUR || 0);
        const hours = Math.floor(decimalHour);
        const remainingMinutes = (decimalHour - hours) * 60;
        const minutes = Math.floor(remainingMinutes);
        const seconds = Math.floor((remainingMinutes - minutes) * 60);

        const hh = hours.toString().padStart(2, "0");
        const mm = minutes.toString().padStart(2, "0");
        const ss = seconds.toString().padStart(2, "0");

        return `${hh}:${mm}`;
      },
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) =>
        row.ATTENDANCESTATUS === 1
          ? (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
            (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
            ? "Approved (No Punches)"
            : (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
                row.PUNCHOUT !== "1900-01-01T00:00:00.000Z"
              ? "Approved (Punch out Only)"
              : row.PUNCHIN !== "1900-01-01T00:00:00.000Z" &&
                  (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
                ? "Approved (Punch In Only)"
                : "Approved"
          : "Approval Pending",
      sortable: true,
      cell: (row) => (
        <span
          className={`px-2 py-1 rounded ${
            row.ATTENDANCESTATUS === 1
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.ATTENDANCESTATUS === 1
            ? (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
              (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
              ? "Approved (No Punches)"
              : (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
                  row.PUNCHOUT !== "1900-01-01T00:00:00.000Z"
                ? "Approved (Punch out Only)"
                : row.PUNCHIN !== "1900-01-01T00:00:00.000Z" &&
                    (!row.PUNCHOUT ||
                      row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
                  ? "Approved (Punch In Only)"
                  : "Approved"
            : "Approval Pending"}
        </span>
      ),
    },

    // {
    //   name: "Punches",
    //   grow: 0,
    //   width: "150px",
    //   selector: (row) => {
    //     const punches = PunchRecords.filter(
    //       (el) =>
    //         el.EMPLOYEEID === row.EMPLOYEEID && el.RECORDDATE === row.RECORDDATE
    //     ).flatMap((el) => {
    //       const parts = [];

    //       if (el.PUNCHIN) {
    //         const d = new Date(el.PUNCHIN);
    //         const hh = d.getUTCHours().toString().padStart(2, "0");
    //         const mm = d.getUTCMinutes().toString().padStart(2, "0");
    //         parts.push(`${hh}:${mm} (in)`);
    //       }

    //       if (el.PUNCHOUT) {
    //         const d = new Date(el.PUNCHOUT);
    //         const hh = d.getUTCHours().toString().padStart(2, "0");
    //         const mm = d.getUTCMinutes().toString().padStart(2, "0");
    //         parts.push(`${hh}:${mm} (out)`);
    //       }

    //       return parts;
    //     });

    //     return (
    //       <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
    //         {punches.join(", ")}
    //       </div>
    //     );
    //   },
    //   sortable: true,

    // },
    {
      name: "Approved by",
      selector: (row) => (row.ATTENDANCESTATUS === 1 ? row.UserName : ""),
      sortable: true,
    },
  ];
  const tableRef = useRef();

  const exportToPDF = () => {
    // Define the date range
    const formatDate = (isoDate) => {
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    };

    const fromDateISO =
      dates.FromDate || new Date().toISOString().split("T")[0];
    const toDateISO = dates.ToDate || new Date().toISOString().split("T")[0];

    const fromDate = formatDate(fromDateISO);
    const toDate = formatDate(toDateISO);

    // const fromDate = dates.FromDate || new Date().toISOString().split("T")[0];
    // const toDate = dates.ToDate || new Date().toISOString().split("T")[0];

    // Initialize jsPDF in landscape mode for more column space
    const doc = new jsPDF("landscape");

    // Get page dimensions
    const pageWidth = doc.internal.pageSize.getWidth();

    // Define table headers
    const tableColumn = [
      "Sl No",
      "Employee Name",
      "Code",
      "Shift",
      "Department",
      "In Time",
      "Out Time",
      "Punch In",
      "Punch Out",
      "Record Date",
      "Working Hours",
      "Attendance",
    ];

    // Group records by department
    const recordsByDepartment = {};

    filteredItems?.forEach((row) => {
      const deptName = row.DepartmentName || "Other";

      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }

      recordsByDepartment[deptName].push(row);
    });

    // Set document properties
    doc.setProperties({
      title: "Attendance Report",
      subject: "Attendance Report by Department",
      creator: `${companyDetails.Name}`,
    });

    let currentY = 20;
    let pageCount = 1;

    // Define the function to add centered title
    const addCenteredTitle = () => {
      const title = `${companyDetails?.Name.toUpperCase()} ATTENDANCE REPORT`;
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);

      // Center the title
      const textWidth = doc.getTextWidth(title);
      const xPos = (pageWidth - textWidth) / 2;
      doc.text(title, xPos, 15);

      // Add date range below the title
      const dateText = `From: ${fromDate} To: ${toDate}`;
      doc.setFontSize(12);
      const dateWidth = doc.getTextWidth(dateText);
      const dateXPos = (pageWidth - dateWidth) / 2;
      doc.text(dateText, dateXPos, 25);

      return 35; // Return the Y position after the titles
    };

    // Add centered title to first page
    currentY = addCenteredTitle();

    // Process each department
    // Process each department
    Object.entries(recordsByDepartment).forEach(
      ([deptName, records], deptIndex) => {
        // Add department header
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(`Department: ${deptName}`, 14, currentY);
        doc.setFont(undefined, "normal");
        currentY += 5;

        // Process records for this department
        const tableRows = records.map((row, index) => {
          // Get punches data
          const punches = [];

          // This is an example of how to extract punches - adjust based on your actual data structure
          if (window.PunchRecords) {
            const rowPunches = PunchRecords.filter(
              (el) =>
                el.EMPLOYEEID === row.EMPLOYEEID &&
                el.RECORDDATE === row.RECORDDATE,
            ).flatMap((el) => {
              const parts = [];
              if (el.PUNCHIN) {
                const d = new Date(el.PUNCHIN);
                const hh = d.getUTCHours().toString().padStart(2, "0");
                const mm = d.getUTCMinutes().toString().padStart(2, "0");
                parts.push(`${hh}:${mm} (in)`);
              }
              if (el.PUNCHOUT) {
                const d = new Date(el.PUNCHOUT);
                const hh = d.getUTCHours().toString().padStart(2, "0");
                const mm = d.getUTCMinutes().toString().padStart(2, "0");
                parts.push(`${hh}:${mm} (out)`);
              }
              return parts;
            });
            punches.push(...rowPunches);
          }

          return [
            index + 1,
            row.EmployeeName || "",
            row.EmployeeCode || "",
            row.IsWeekly == 1 ? "Weekly Off" : row.ShiftName || "",
            row.DepartmentName || "",
            row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "-",
            row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "-",
            row.PUNCHIN && row.PUNCHIN !== "1900-01-01T00:00:00.000Z"
              ? row.PUNCHIN.split("T")[1]?.slice(0, 5)
              : "-",
            row.PUNCHOUT && row.PUNCHOUT !== "1900-01-01T00:00:00.000Z"
              ? row.PUNCHOUT.split("T")[1]?.slice(0, 5)
              : "-",
            row.RECORDDATE
              ? new Date(row.RECORDDATE).toLocaleDateString("en-GB")
              : "",
            (() => {
              const decimalHour = parseFloat(row.WORKINGHOUR || 0);
              if (!decimalHour) return "-";

              const hours = Math.floor(decimalHour);
              const remainingMinutes = (decimalHour - hours) * 60;
              const minutes = Math.floor(remainingMinutes);
              const seconds = Math.floor((remainingMinutes - minutes) * 60);

              const hh = hours.toString().padStart(2, "0");
              const mm = minutes.toString().padStart(2, "0");
              const ss = seconds.toString().padStart(2, "0");

              return `${hh}:${mm}`;
            })(),
            (() => {
              const isPunchInDefault =
                !row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z";
              const isPunchOutDefault =
                !row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z";

              if (row.ATTENDANCESTATUS !== 1) return "Approval Pending";
              if (isPunchInDefault && isPunchOutDefault)
                return "Approved (No Punches)";
              if (isPunchInDefault && !isPunchOutDefault)
                return "Approved (Punch out Only)";
              if (!isPunchInDefault && isPunchOutDefault)
                return "Approved (Punch In Only)";
              return "Approved";
            })(),
          ];
        });

        // Add table for this department
        doc.autoTable({
          startY: currentY,
          head: [tableColumn],
          body: tableRows,
          styles: {
            fontSize: 7,
            cellPadding: 2,
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255], // White background
            textColor: [0, 0, 0], // Black text
            fontStyle: "bold",
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
          bodyStyles: {
            fillColor: [255, 255, 255], // White background for all rows
          },
          margin: { top: 20, right: 14, bottom: 20, left: 14 },
          tableLineWidth: 0.5,
          tableLineColor: [0, 0, 0],
        });

        // Update position for next department or signature
        currentY = doc.previousAutoTable.finalY + 8;

        // Check if this is the last department
        if (deptIndex === Object.keys(recordsByDepartment).length - 1) {
          // Add signature field
          if (currentY > doc.internal.pageSize.height - 40) {
            doc.addPage();
            currentY = 20;
            pageCount++;
            // Add page number to new page
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            doc.text(
              `Page ${pageCount}`,
              doc.internal.pageSize.width - 25,
              doc.internal.pageSize.height - 10,
            );
          }

          // Add signature label and line
          doc.setFontSize(10);
          doc.setFont(undefined, "bold");
          doc.setTextColor(0, 0, 0);
          doc.text(" Signature:", 14, currentY);
          currentY += 5;
          doc.setLineWidth(0.2);
          doc.line(14, currentY, 64, currentY); // Draw a 50mm line for signature
          currentY += 10; // Add space after signature line
        } else {
          // Add new page if necessary for next department
          if (currentY > doc.internal.pageSize.height - 40) {
            doc.addPage();
            currentY = addCenteredTitle();
            pageCount++;
            // Add page number
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            doc.text(
              `Page ${pageCount}`,
              doc.internal.pageSize.width - 25,
              doc.internal.pageSize.height - 10,
            );
          }
        }
      },
    );

    // Add generation date to bottom right
    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString("en-GB")}`;
    const generatedBy = `Generated by: ${UserName}`;

    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);

    const textWidth = doc.getTextWidth(generatedText);
    const marginRight = 14; // Adjust for padding
    const lineSpacing = 4; // Adjust for spacing between lines

    // Render the generated text
    doc.text(
      generatedText,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20,
    );

    // Render the generated by text below the generated text
    doc.text(
      generatedBy,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20 + lineSpacing,
    );

    // Add page number to first page
    doc.setPage(1);
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Page 1`,
      doc.internal.pageSize.width - 25,
      doc.internal.pageSize.height - 10,
    );

    // Save the PDF
    doc.save(`Attendance_Report_${fromDate}_to_${toDate}.pdf`);
  };

  const exportToExcel = () => {
    const fromDate = dates.FromDate || new Date().toISOString().split("T")[0];
    const toDate = dates.ToDate || new Date().toISOString().split("T")[0];

    const recordsByDepartment = {};

    filteredItems?.forEach((row) => {
      const deptName = row.DepartmentName || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    const workbook = XLSX.utils.book_new();

    Object.entries(recordsByDepartment)?.forEach(([deptName, records]) => {
      const dataToExport = records?.map((row, index) => ({
        "Sl No": index + 1,
        "Employee Name": row.EmployeeName || "",
        "Employee Code": row.EmployeeCode || "",

        Shift: row.ShiftName || "",
        Department: row.DepartmentName || "",
        "In Time": row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "-",
        "Out Time": row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "-",
        "Punch In": row.PUNCHIN ? row.PUNCHIN.split("T")[1]?.slice(0, 5) : "-",
        "Punch Out": row.PUNCHOUT
          ? row.PUNCHOUT.split("T")[1]?.slice(0, 5)
          : "-",
        "Working Hours": (() => {
          const decimalHour = parseFloat(row.WORKINGHOUR || 0);
          if (!decimalHour) return "-";

          const hours = Math.floor(decimalHour);
          const remainingMinutes = (decimalHour - hours) * 60;
          const minutes = Math.floor(remainingMinutes);
          const seconds = Math.floor((remainingMinutes - minutes) * 60);

          const hh = hours.toString().padStart(2, "0");
          const mm = minutes.toString().padStart(2, "0");
          const ss = seconds.toString().padStart(2, "0");

          return `${hh}:${mm}:${ss}`;
        })(),
        Attendance:
          row.ATTENDANCESTATUS === 1 ? "Approved" : "Approval Pending",
        "Approved By": row.ATTENDANCESTATUS === 1 ? row.UserName : "",
      }));

      const worksheet = XLSX.utils.json_to_sheet([]);

      // Add title rows first (row 1 & 2)
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [
          [`${companyDetails.Name} Attendance Report`],
          [`From: ${fromDate} To: ${toDate}`],
        ],
        { origin: "A1" },
      );

      // Merge title rows
      if (!worksheet["!merges"]) worksheet["!merges"] = [];
      worksheet["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } });
      worksheet["!merges"].push({ s: { r: 1, c: 0 }, e: { r: 1, c: 10 } });

      // Add department header (row 3)
      XLSX.utils.sheet_add_aoa(worksheet, [[`Department: ${deptName}`]], {
        origin: "A3",
      });

      // Add column headers (row 4)
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [
          [
            "Sl No",
            "Employee Name",
            "Employee Code",
            "Shift",
            "Department",
            "In Time",
            "Out Time",
            "Punch In",
            "Punch Out",
            "Working Hours",
            "Attendance",
            "Approved By",
          ],
        ],
        { origin: "A4" },
      );

      // Add the main data (from row 5)
      XLSX.utils.sheet_add_json(worksheet, dataToExport, {
        origin: "A5",
        skipHeader: true,
      });

      // Sanitize department name to make it Excel-safe
      let safeDeptName = deptName.replace(/[:\\/?*\[\]]/g, "").substring(0, 31);

      if (safeDeptName.length > 31) {
        safeDeptName = safeDeptName.substring(0, 31);
      }

      // Append sheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, safeDeptName);
    });

    // Add generated date to last sheet
    const lastSheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
    const lastSheet = workbook.Sheets[lastSheetName];
    const lastRow = XLSX.utils.decode_range(lastSheet["!ref"] || "A1").e.r + 2;

    XLSX.utils.sheet_add_aoa(
      lastSheet,
      [[`Generated on: ${new Date().toLocaleDateString()}`]],
      { origin: { r: lastRow, c: 0 } },
    );

    XLSX.writeFile(workbook, `Attendance_Report_${fromDate}_to_${toDate}.xlsx`);
  };
const exportNullPunchesToPDF = () => {
  console.log(filteredItems,'dasda');
  
    if (!employeesWithNullPunches.length) {
      toast.error("No employees with null or empty punches found");
      return;
    }

    const formatDate = (isoDate) => {
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    };

    const fromDateISO =
      dates.FromDate || new Date().toISOString().split("T")[0];
    const toDateISO = dates.ToDate || new Date().toISOString().split("T")[0];
    const fromDate = formatDate(fromDateISO);
    const toDate = formatDate(toDateISO);

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();

    // Define table headers - Shift Start/End kept for context, Punch In/Out are the actual punches
    const tableColumn = [
      "Sl No",
      "Employee Name",
      "Code",
      "Shift",
      "Department",
      "Shift Start",
      "Shift End",
      "Record Date",
      "Punch In",
      "Punch Out",
      "Working Hours",
      "Attendance",
      "Approved By",
    ];

    // Group records by department
    const recordsByDepartment = {};
    employeesWithNullPunches.forEach((row) => {
      const deptName = row.DepartmentName || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    doc.setProperties({
      title: "Employees with Mannual Approved  Report",
      subject: "Report of Employees with Null or Empty Punches",
      creator: `${companyDetails.Name}`,
    });

    let currentY = 20;
    let pageCount = 1;

    const addCenteredTitle = () => {
      const title = `${companyDetails?.Name.toUpperCase()} - EMPLOYEES WITH MANNUAL APPROVED`;
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      const textWidth = doc.getTextWidth(title);
      const xPos = (pageWidth - textWidth) / 2;
      doc.text(title, xPos, 15);

      const dateText = `Period: ${fromDate} to ${toDate}`;
      doc.setFontSize(12);
      const dateWidth = doc.getTextWidth(dateText);
      const dateXPos = (pageWidth - dateWidth) / 2;
      doc.text(dateText, dateXPos, 25);

      return 35;
    };

    currentY = addCenteredTitle();

    Object.entries(recordsByDepartment).forEach(
      ([deptName, records], deptIndex) => {
        // Add department header
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(`Department: ${deptName}`, 14, currentY);
        doc.setFont(undefined, "normal");
        currentY += 5;

        // Create table rows - Shift Start/End (INTIME/OUTTIME) then Punch In/Out (PUNCHIN/PUNCHOUT)
        const tableRows = records.map((row, index) => [
          index + 1,
          row.EmployeeName || "",
          row.EmployeeCode || "",
          row.IsWeekly == 1 ? "Weekly Off" : row.ShiftName || "",
          row.DepartmentName || "",
          row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "-",
          row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "-",
          row.RECORDDATE
            ? new Date(row.RECORDDATE).toLocaleDateString("en-GB")
            : "",
          row.PUNCHIN ? row.PUNCHIN.split("T")[1]?.slice(0, 5) : "-",
          row.PUNCHOUT ? row.PUNCHOUT.split("T")[1]?.slice(0, 5) : "-",
          (() => {
            const decimalHour = parseFloat(row.WORKINGHOUR || 0);
            if (!decimalHour) return "-";
            const hours = Math.floor(decimalHour);
            const remainingMinutes = (decimalHour - hours) * 60;
            const minutes = Math.floor(remainingMinutes);
            const hh = hours.toString().padStart(2, "0");
            const mm = minutes.toString().padStart(2, "0");
            return `${hh}:${mm}`;
          })(),
          row.ATTENDANCESTATUS === 1 ? "Approved" : "Approval Pending",
          row.UserName || "",
        ]);

        // Add table for this department - black and white styling
        doc.autoTable({
          startY: currentY,
          head: [tableColumn],
          body: tableRows,
          styles: {
            fontSize: 7,
            cellPadding: 2,
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
            textColor: [0, 0, 0],
          },
          headStyles: {
            fillColor: [255, 255, 255], // White background
            textColor: [0, 0, 0], // Black text
            fontStyle: "bold",
            halign: "center",
            lineWidth: 0.2,
            lineColor: [0, 0, 0],
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245], // Light gray for alternate rows
          },
          bodyStyles: {
            fillColor: [255, 255, 255], // White background
            textColor: [0, 0, 0],
          },
          margin: { top: 20, right: 14, bottom: 20, left: 14 },
          tableLineWidth: 0.5,
          tableLineColor: [0, 0, 0],
        });

        currentY = doc.previousAutoTable.finalY + 8;

        // Add new page if necessary for next department
        if (deptIndex !== Object.keys(recordsByDepartment).length - 1) {
          if (currentY > doc.internal.pageSize.height - 40) {
            doc.addPage();
            currentY = addCenteredTitle();
            pageCount++;
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            doc.text(
              `Page ${pageCount}`,
              doc.internal.pageSize.width - 25,
              doc.internal.pageSize.height - 10,
            );
          }
        }
      },
    );

    // Add footer information
    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString("en-GB")}`;
    const generatedBy = `Generated by: ${UserName}`;
    const totalRecords = `Total Employees with Mannual Approved: ${employeesWithNullPunches.length}`;

    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);

    // Add total records at bottom left
    doc.text(totalRecords, 14, doc.internal.pageSize.height - 20);

    const textWidth = doc.getTextWidth(generatedText);
    const marginRight = 14;
    const lineSpacing = 4;

    doc.text(
      generatedText,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20,
    );
    doc.text(
      generatedBy,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20 + lineSpacing,
    );

    doc.setPage(1);
    doc.setFontSize(8);
    doc.text(
      `Page 1`,
      doc.internal.pageSize.width - 25,
      doc.internal.pageSize.height - 10,
    );

    doc.save(`Employees_With_Missing_Punches_${fromDate}_to_${toDate}.pdf`);
  };

  // New Excel export for employees with null/empty punches
  const exportNullPunchesToExcel = () => {
    if (!employeesWithNullPunches.length) {
      toast.error("No employees with null or empty punches found");
      return;
    }

    const fromDate = dates.FromDate || new Date().toISOString().split("T")[0];
    const toDate = dates.ToDate || new Date().toISOString().split("T")[0];

    const formatDate = (isoDate) => {
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    };

    const fromDateFormatted = formatDate(fromDate);
    const toDateFormatted = formatDate(toDate);

    const recordsByDepartment = {};
    employeesWithNullPunches.forEach((row) => {
      const deptName = row.DepartmentName || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    const workbook = XLSX.utils.book_new();

    Object.entries(recordsByDepartment).forEach(([deptName, records]) => {
      // Create data with Shift Start/End AND Punch In/Out columns
      const dataToExport = records.map((row, index) => ({
        "Sl No": index + 1,
        "Employee Name": row.EmployeeName || "",
        "Employee Code": row.EmployeeCode || "",
        Shift: row.ShiftName || "",
        Department: row.DepartmentName || "",
        "Shift Start": row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "-",
        "Shift End": row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "-",
        "Record Date": row.RECORDDATE
          ? new Date(row.RECORDDATE).toLocaleDateString("en-GB")
          : "",
        "Punch In": row.PUNCHIN ? row.PUNCHIN.split("T")[1]?.slice(0, 5) : "-",
        "Punch Out": row.PUNCHOUT ? row.PUNCHOUT.split("T")[1]?.slice(0, 5) : "-",
        "Working Hours": (() => {
          const decimalHour = parseFloat(row.WORKINGHOUR || 0);
          if (!decimalHour) return "-";
          const hours = Math.floor(decimalHour);
          const remainingMinutes = (decimalHour - hours) * 60;
          const minutes = Math.floor(remainingMinutes);
          const seconds = Math.floor((remainingMinutes - minutes) * 60);
          const hh = hours.toString().padStart(2, "0");
          const mm = minutes.toString().padStart(2, "0");
          const ss = seconds.toString().padStart(2, "0");
          return `${hh}:${mm}:${ss}`;
        })(),
        Attendance:
          row.ATTENDANCESTATUS === 1 ? "Approved" : "Approval Pending",
        "Approved By": row.ATTENDANCESTATUS === 1 ? row.UserName : "",
      }));

      const worksheet = XLSX.utils.json_to_sheet([]);

      // Add title rows
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [
          [`${companyDetails.Name} - Employees with Mannual Approved Report`],
          [`Period: ${fromDateFormatted} to ${toDateFormatted}`],
        ],
        { origin: "A1" },
      );

      if (!worksheet["!merges"]) worksheet["!merges"] = [];
      worksheet["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 12 } });
      worksheet["!merges"].push({ s: { r: 1, c: 0 }, e: { r: 1, c: 12 } });

      // Add department header
      XLSX.utils.sheet_add_aoa(worksheet, [[`Department: ${deptName}`]], {
        origin: "A3",
      });

      // Add column headers (with Shift Start/End AND Punch In/Out)
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [
          [
            "Sl No",
            "Employee Name",
            "Employee Code",
            "Shift",
            "Department",
            "Shift Start",
            "Shift End",
            "Record Date",
            "Punch In",
            "Punch Out",
            "Working Hours",
            "Attendance",
            "Approved By",
          ],
        ],
        { origin: "A4" },
      );

      // Add the main data
      XLSX.utils.sheet_add_json(worksheet, dataToExport, {
        origin: "A5",
        skipHeader: true,
      });

      let safeDeptName = deptName.replace(/[:\\/?*\[\]]/g, "").substring(0, 20);
      let sheetName = `${safeDeptName}_Missing`;
      if (sheetName.length > 31) {
        sheetName = sheetName.substring(0, 31);
      }
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    const lastSheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
    const lastSheet = workbook.Sheets[lastSheetName];
    const lastRow = XLSX.utils.decode_range(lastSheet["!ref"] || "A1").e.r + 2;

    XLSX.utils.sheet_add_aoa(
      lastSheet,
      [[`Total Records: ${employeesWithNullPunches.length}`]],
      { origin: { r: lastRow, c: 0 } },
    );
    XLSX.utils.sheet_add_aoa(
      lastSheet,
      [[`Generated on: ${new Date().toLocaleDateString()}`]],
      { origin: { r: lastRow + 1, c: 0 } },
    );

    XLSX.writeFile(
      workbook,
      `Employees_With_Missing_Punches_${fromDate}_to_${toDate}.xlsx`,
    );
  };

  useEffect(() => {
    if (AttendenceReports && AttendenceReports.length > 0) {
      setDataFilter(AttendenceReports);
    } else {
      setDataFilter([]);
    }
  }, [AttendenceReports]);

  const handleFilter = (filteredResults) => {
    console.log(filteredResults, "asdasds");
    setDataFilter(filteredResults); 
  };

  const filteredItems = dataFilter?.filter((item) => {
    return (
      item.EmployeeName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.DepartmentName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.ShiftName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.UserName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.EmployeeCode?.toString()
        .toLowerCase()
        .includes(filterText.toLowerCase())
    );
  });
  // Filter employees with null or empty punches
  const employeesWithNullPunches = (filteredItems || []).filter(
    (item) => item.IsMannual == 1 || item.IsMannual == true,
  );

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterPages, setFilterPages] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");
  useEffect(() => {
    const fetchfilterPage = async () => {
      try {
        const response = await getPages(UID);

        // Filter the response to only include the desired page names
        const filteredPages = response.data.data.filter((page) =>
          [
            "Category",
            "Profit Center",
            "Group",
            "Designation",
            "Department",
          ].includes(page.Name),
        );

        setFilterPages(filteredPages);
        console.log(filteredPages, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchfilterPage();
  }, []);

  const [category, setCategory] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [group, setGroup] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);

        setCategory(response);
        console.log(category, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchcategory();
  }, []);

  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID);

        setdesignation(response);
        console.log(designation, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchdesignation();
  }, []);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);

        setGroup(response);
        console.log(group, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchGroup();
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);

        setDepartment(response);
        console.log(Department, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);

        setFilterProfitcenter(response);
        console.log(FilterProfitcenter, "Filtered Pages");
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchfilterProfitecenter();
  }, []);

  useEffect(() => {
    const uniqueShifts = Array.from(
      new Map(filteredItems.map((item) => [item.ShiftId, item])).values(),
    );

    console.log(
      "filteredItems",
      uniqueShifts.map((el) => ({
        ShiftId: el.ShiftId,
        ShiftName: el.ShiftName,
      })),
    );
    const shiftoptions = uniqueShifts.map((el) => ({
      Id: el.ShiftId,
      Name: el.ShiftName,
    }));
    console.log("category?.data?.data", category?.data?.data);

    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;

      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department?.data?.data);
        break;
      case "ShiftId":
        setDropdownOptions(shiftoptions);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

  const handleFilterChange = async (selectedMethod, Name, Id) => {
    setFilterMethod(selectedMethod);
    const requestData = {
      UserId: UID,
      name: selectedMethod,
      Id,
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0], // Include FromDate
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0], // Include ToDate
    };

    console.log("Request Data:", requestData);

    try {
      setLoading(true);
      const response = await GetAttendanceReport(requestData);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      setAttendenceReports(details);
      setAttendenceReports(details);
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadEditedInAndOut = () => {
    if (!editedReport || !editedReport[0] || editedReport[0].length === 0) {
      toast.error("No changes on In time and Out Time");
      return;
    }

    // PDF in portrait mode with A3 size
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a3", // A3 size: 297mm x 420mm
    });

    // Format date helper function
    const formatDate = (isoDate) => {
      if (!isoDate) return "N/A";
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    };

    function extractTime(input) {
      if (!input) {
        return "Invalid Time";
      }

      // Parse the input into a Date object
      const date = new Date(input);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return "Invalid Time";
      }

      // Use toLocaleTimeString with UTC options to handle timezone correctly
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC", // Adjust this based on your application's needs
      });
    }

    // Format time helper function
    const formatDateTime = (dateTimeStr) => {
      if (!dateTimeStr) return "N/A";
      try {
        const date = new Date(dateTimeStr);
        if (isNaN(date.getTime())) return "N/A";

        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${day}/${month}/${year}\n${hours}:${minutes}`;
      } catch (e) {
        return "N/A";
      }
    };

    // Compare values function
    const compareValues = (oldVal, newVal) => {
      if (oldVal === newVal) return "No Change";
      if (!oldVal) return "Added";
      if (!newVal) return "Removed";
      return newVal;
    };

    const fromDateISO =
      dates.FromDate || new Date().toISOString().split("T")[0];
    const toDateISO = dates.ToDate || new Date().toISOString().split("T")[0];

    const fromDate = formatDate(fromDateISO);
    const toDate = formatDate(toDateISO);

    // Set document properties
    doc.setProperties({
      title: `${companyDetails.Name} - Shift Details Report`,
      subject: `Report for Updated Employee Shift Details from ${fromDate} to ${toDate}`,
      author: "System Generated",
      creator: companyDetails.Name,
    });

    // Add company header
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");

    // Center company name
    const companyName = companyDetails.Name || "Company Name";
    const companyNameWidth =
      (doc.getStringUnitWidth(companyName) * 16) / doc.internal.scaleFactor;
    const companyNameX = (doc.internal.pageSize.width - companyNameWidth) / 2;
    doc.text(companyName, companyNameX, 12);

    // Add report title
    doc.setFontSize(12);
    const reportTitle = "Updated Employee Shift Details Report";
    const reportTitleWidth =
      (doc.getStringUnitWidth(reportTitle) * 12) / doc.internal.scaleFactor;
    const reportTitleX = (doc.internal.pageSize.width - reportTitleWidth) / 2;
    doc.text(reportTitle, reportTitleX, 18);

    // Add date range
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const dateRangeText = `Period: ${fromDate} to ${toDate}`;
    const dateRangeWidth =
      (doc.getStringUnitWidth(dateRangeText) * 10) / doc.internal.scaleFactor;
    const dateRangeX = (doc.internal.pageSize.width - dateRangeWidth) / 2;
    doc.text(dateRangeText, dateRangeX, 23);

    // Generate the table data with status indicators
    const tableData = editedReport[0].map((record, index) => {
      // Format times
      return [
        index + 1, // Serial Number
        record.EmployeeName || "N/A",
        record.EmployeeCode || "N/A",
        record.RECORDDATE
          ? new Date(record.RECORDDATE).toLocaleDateString("en-GB")
          : "N?A",
        extractTime(record.OldInTime),
        extractTime(record.UpdatedInTime),
        extractTime(record.OldOutTime),
        extractTime(record.UpdatedOutTime),
        record.OldShiftName || "N/A",
        record.UpdatedShiftName,
        record.OldDepName || "N/A",
        record.UpdatedDepName,
        formatDateTime(record.UpdatedAt),
        record.UpdatedUserName || "N/A",
      ];
    });

    // Add Table with optimized styling to fit full A3 page width without overflow
    doc.autoTable({
      head: [
        [
          "Sl.",
          "Employee Name",
          "Code",
          "RecordDate",
          "Old In Time",
          "New In Time",
          "Old Out Time",
          "New Out Time",
          "Old Shift",
          "New Shift",
          "Old Dept",
          "New Dept",
          "Updated On",
          "Updated By",
        ],
      ],
      body: tableData,
      startY: 28, // Minimal top spacing
      margin: { top: 28, left: 5, right: 3, bottom: 15 }, // Consistent 3mm left/right margins
      styles: {
        fontSize: 7.5, // Adjusted for readability
        cellPadding: { top: 1.2, right: 1.2, bottom: 1.2, left: 1.2 }, // Tight padding
        overflow: "linebreak",
        lineWidth: 0.1,
        lineColor: [50, 50, 50], // Dark borders
        minCellHeight: 5, // Compact rows
        font: "helvetica",
      },
      headStyles: {
        fillColor: [230, 230, 230], // Light gray header
        textColor: [0, 0, 0], // Black text
        fontStyle: "bold",
        halign: "center",
        lineWidth: 0.2,
        lineColor: [50, 50, 50],
        minCellHeight: 6, // Compact header
      },
      columnStyles: {
        0: { cellWidth: 8, halign: "center" }, // Sl. No
        1: { cellWidth: 35, halign: "left" }, // Employee Name
        2: { cellWidth: 18, halign: "center" }, // Emp. Code
        3: { cellWidth: 22, halign: "center" }, // Old In Time
        4: { cellWidth: 22, halign: "center" }, // New In Time
        5: { cellWidth: 22, halign: "center" }, // Old Out Time
        6: { cellWidth: 22, halign: "center" }, // New Out Time
        7: { cellWidth: 18, halign: "center" }, // Old Shift
        8: { cellWidth: 18, halign: "center" }, // New Shift
        9: { cellWidth: 22, halign: "left" }, // Old Department
        10: { cellWidth: 22, halign: "left" }, // New Department
        11: { cellWidth: 22, halign: "center" }, // Updated At
        12: { cellWidth: 20, halign: "left" }, // Updated By
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245], // Subtle alternate row color
      },
      didDrawPage: function (data) {
        // Add page number at footer
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        const pageNumberText = `Page ${doc.internal.getNumberOfPages()}`;
        doc.text(
          pageNumberText,
          data.settings.margin.left,
          doc.internal.pageSize.height - 8,
        );

        // Add timestamp at footer
        const now = new Date();
        const timestamp = `Generated on: ${formatDateTime(now.toISOString())}`;
        const timestampWidth =
          (doc.getStringUnitWidth(timestamp) * 8) / doc.internal.scaleFactor;
        doc.text(
          timestamp,
          doc.internal.pageSize.width -
            data.settings.margin.right -
            timestampWidth,
          doc.internal.pageSize.height - 8,
        );
      },
    });

    // Add summary footer
    const totalRecords = editedReport[0].length;
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Total Records: ${totalRecords}`,
      3,
      doc.autoTable.previous.finalY + 8,
    );

    // Save the PDF with a descriptive filename
    doc.save(
      `${companyDetails.Name}_ShiftDetailsReport_${fromDate}_to_${toDate}.pdf`,
    );
  };

  return (
    <>
      <div className="flex flex-col md:flex-row items-center justify-between mb-8">
        <div className="flex flex-col md:flex-row gap-4 md:gap-[40px] w-full mb-4 md:mb-0">
          <Breadcrumb title="Approved Attendance Report" />
          <b className="text-xl">
            Total Employees:{" "}
            {AttendenceReports?.length ? AttendenceReports?.length : 0}
          </b>
        </div>

        {AttendenceReports?.length ? (
          <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
            <div className="flex flex-col md:flex-row items-center gap-2 p-5 bg-gray-100 rounded w-full md:w-auto">
              <button
                className="bg-sky rounded-[4px] px-10 py-[8px]"
                onClick={handleFilterClick}
              >
                <IconFilter className="text-white w-[18px] h-[18px]" />
              </button>
              <div className="relative w-full md:w-[400px]">
                <input
                  type="text"
                  id="search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Search by Emp Name/Code/Dep/shift/Approved by"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <button
                onClick={handleClear}
                className="btn btn-danger w-full md:w-auto mt-2 md:mt-0"
              >
                Clear
              </button>
            </div>
            <div className="flex flex-row gap-4 w-full md:w-auto justify-center md:justify-start items-center">
              <button
                onClick={exportToExcel}
                className="btn btn-primary w-full md:w-auto"
              >
                Excel
              </button>
              <button
                onClick={exportToPDF}
                className="btn btn-danger w-full md:w-auto"
              >
                PDF
              </button>
              <button
                onClick={exportNullPunchesToExcel}
                className="bg-green-600 hover:bg-green-700 text-white rounded-md w-full md:w-auto px-4 py-2 text-sm font-medium"
              >
                Manual Approved Excel
              </button>
              <button
                onClick={exportNullPunchesToPDF}
                className="bg-red-800 hover:bg-red-700 text-white rounded-md w-full md:w-auto px-4 py-2 text-sm font-medium"
              >
                Manual Approved PDF
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={AttendenceReports}
          onFilter={handleFilter}
        />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="flex items-center p-4">
          <label
            htmlFor="from-date-input"
            className="text-sm font-medium text-gray-700 mr-2"
          >
            From
          </label>
          <input
            type="date"
            name="FromDate"
            onChange={handleDateChange}
            value={dates.FromDate}
            id="from-date-input"
            className="w-[200px]  px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
          />

          <label
            htmlFor="to-date-input"
            className="text-sm font-medium text-gray-700 mx-2"
          >
            To
          </label>
          <input
            type="date"
            name="ToDate"
            onChange={handleDateChange}
            value={dates.ToDate}
            id="to-date-input"
            className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
          />

          <button className="btn btn-success ml-4" onClick={handleClick}>
            Show
          </button>

          <select
            id="filter-method"
            name="filter-method"
            className="ml-4 w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
            value={filterMethod}
            onChange={(e) => setFilterMethod(e.target.value)}
          >
            <option value="">Filter By</option>
            <option value="CategoryId">Category</option>
            <option value="ProfitCenterID">Profit Center</option>
            <option value="GroupId">Group</option>
            <option value="DesignationId">Designation</option>
            <option value="DepartmentID">Department</option>
            <option value="ShiftId">Shift</option>
          </select>

          <select
            id="dynamic-options"
            name="dynamic-options"
            className="ml-4 w-[200px]  px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
            onChange={(e) => {
              const selectedOption = dropdownOptions.find(
                (option) => option.Id.toString() === e.target.value,
              );
              if (selectedOption) {
                handleFilterChange(
                  filterMethod,
                  selectedOption.FromDate,
                  selectedOption.Id,
                  selectedOption.ToDate,
                  filterMethod,
                );
              }
            }}
          >
            <option value="" selected>
              Choose One
            </option>
            {dropdownOptions?.length > 0 &&
              dropdownOptions.map((option) => (
                <option key={option.Id} value={option.Id}>
                  {option.Name}
                </option>
              ))}
          </select>

          <button
            className="btn btn-primary ms-2"
            onClick={handleDownloadEditedInAndOut}
          >
            Download IN-TIME OUT-TIME EDIT REPORT
          </button>
        </div>

        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <div ref={tableRef}>
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems.length ? filteredItems : []}
                pagination
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
